/**
 * Public contact page — FeedbackForm type="contact" (CUSTOMER_FEEDBACK_PLAN Task 2.2).
 *
 * Lists every intake channel, states what happens next (a ticket ref), and sets
 * an honest response expectation. Does not promise an SLA.
 */

import { FeedbackForm } from "../components/feedback/FeedbackForm.js";
import { PageHeader } from "../components/ui/PageHeader.js";

export function ContactPage() {
  return (
    <div className="mx-auto w-full max-w-2xl px-4 py-8 sm:py-10">
      <PageHeader
        title="Contact us"
        subtitle="Something wrong? Tell us. Send a message, report a bug, or ask for a feature. You will get a ticket reference you can check later."
      />

      <div className="space-y-8">
        <section aria-labelledby="contact-channels">
          <h2 id="contact-channels" className="text-base font-semibold text-ink">
            Ways to reach us
          </h2>
          <ul className="mt-3 list-disc space-y-2 pl-5 text-sm text-muted">
            <li>
              <span className="text-ink">This form</span> — general questions, account help, or anything else.
            </li>
            <li>
              <span className="text-ink">Report a problem</span> — bug or feature dialog from the account menu or footer when you are signed in.
            </li>
            <li>
              <a href="/privacy" className="font-medium text-brand-700 no-underline hover:underline">
                Privacy
              </a>
              {" — "}what we collect with feedback and how long we keep it.
            </li>
          </ul>
        </section>

        <section aria-labelledby="contact-what-next">
          <h2 id="contact-what-next" className="text-base font-semibold text-ink">
            What happens next
          </h2>
          <p className="mt-2 text-sm leading-relaxed text-muted">
            Every submission creates a tracked ticket with a reference like{" "}
            <code className="rounded bg-slate-100 px-1.5 py-0.5 font-mono text-xs text-ink">
              CHK-…
            </code>
            . We read every message. We do not promise a reply time — leave an email only if
            you want one when there is something to say.
          </p>
        </section>

        <section aria-labelledby="contact-form-heading">
          <h2 id="contact-form-heading" className="sr-only">
            Contact form
          </h2>
          <FeedbackForm type="contact" />
        </section>
      </div>
    </div>
  );
}
